// src/utils/authUtils.js

/**
 * Get the redirect path after login
 * @returns {string} The path to redirect to after login
 */
export const getRedirectPath = () => {
    // Check for stored redirect path in session storage
    const redirectPath = sessionStorage.getItem('authRedirectPath');

    // Clear the stored path
    if (redirectPath) {
        sessionStorage.removeItem('authRedirectPath');
    }

    // Return the path or default to dashboard
    return redirectPath || '/';
};

/**
 * Set the redirect path for after login
 * @param {string} path - The path to redirect to after login
 */
export const setRedirectPath = (path) => {
    if (path && path !== '/auth') {
        sessionStorage.setItem('authRedirectPath', path);
    }
};

/**
 * Parse error messages from API responses
 * @param {Error} error - The error object from axios or other sources
 * @returns {string} A user-friendly error message
 */
export const parseAuthError = (error) => {
    if (error.response) {
        // Server responded with a non-2xx status
        const data = error.response.data;

        if (data && data.error) {
            return data.error;
        }

        if (error.response.status === 401) {
            return 'Invalid credentials. Please check your email and password.';
        }

        if (error.response.status === 403) {
            return 'You do not have permission to access this resource.';
        }

        return `Authentication error: ${error.response.status}`;
    }

    if (error.request) {
        // Request was made but no response received
        return 'No response from server. Please check your network connection.';
    }

    // Something else happened while setting up the request
    return error.message || 'An unexpected error occurred.';
};